/**
 * A completed/cancelled/expired Checker trip: a globe icon, title, a
 * check-in count, and "Reuse this trip". Mirrors the Android app's
 * PastTripCard, including its choice to always show "Completed" regardless
 * of the trip's actual end status.
 *
 * @param {Object} trip - Raw trip fields (title, completed_checkins_count)
 * @param {() => void} onReuse
 * @param {() => void} onShowEvents - No Android equivalent; see CheckerTripCard.
 */
export default function CheckerPastTripCard({ trip, onReuse, onShowEvents }) {
    return (
        <article className="checker-past-trip-card">
            <div className="checker-past-trip-top">
                <span className="checker-past-trip-icon" aria-hidden="true">
                    🌍
                </span>
                <div className="checker-past-trip-text">
                    <div className="checker-past-trip-title">{trip.title}</div>
                    <div className="checker-past-trip-meta">
                        <i className="bi bi-check-lg checker-past-trip-check" aria-hidden="true"></i>
                        Completed · {trip.completed_checkins_count} check-ins
                    </div>
                </div>
                <button
                    type="button"
                    className="checker-trip-timeline-button"
                    onClick={onShowEvents}
                    title="View timeline"
                    aria-label="View timeline"
                >
                    <i className="bi bi-clock-history" aria-hidden="true"></i>
                </button>
            </div>

            <button
                type="button"
                className="btn checker-past-trip-reuse"
                onClick={onReuse}
            >
                <i className="bi bi-arrow-clockwise me-1" aria-hidden="true"></i>
                Reuse this trip
            </button>
        </article>
    )
}
